import React from 'react'
import { useEffect } from 'react';
import aboutPhoto from '../assets/images/aboutphotofinal.jpg';

import DescImage from '../components/DescImage';
import TitleBtn from '../components/TitleBtn';
import BackArrow from '../components/BackArrow';
import WhoCont from '../components/WhoCont';
import BackgroundCont from '../components/BackgroundCont';
import SkillCont from '../components/SkillCont';
import ScrollToTop from '../components/ScrollToTop';
import { useNavigate } from 'react-router-dom';
import ScrollDown from '../components/ScrollDown';

import { FullWrap, DetailContainer, DetailDesc, LowerSec } from '../components/StyledComponents/StyledComp';
import DownBtn from '../components/DownBtn';


function AboutDetail() {

    useEffect(() => {
        // Calculate 1/4 of the total viewport height
        const timer = setTimeout(() => {
            const scrollAmount = window.innerHeight / 3;
            const overshoot = scrollAmount + 50;

            // 2. Trigger the scroll
            window.scrollTo({
                top: overshoot,
                behavior: 'smooth'
            });

        }, 1000);
        return () => clearTimeout(timer);

    }, []);

    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }

    return (
        <FullWrap>
            <DetailContainer
            >
                <BackArrow />
                <DetailDesc>
                    <p className="title-text">About Me</p>
                    <div className="redline1"></div>
                    <div className="redline2"></div>
                    <div className="role">
                        <p className='title-lead' >Who I am</p>
                        <p className='title-lead' >(Beyond job titles)</p>
                    </div>
                    <DownBtn />
                </DetailDesc>
                <DescImage photoSource={aboutPhoto} />
                <ScrollDown />
            </DetailContainer>


            <LowerSec>
                <WhoCont />
                <BackgroundCont />
                <SkillCont />
                <div className="scroll-to-top">
                    <ScrollToTop />
                </div>
            </LowerSec>

        </FullWrap>
    )
}

export default AboutDetail